import React from 'react';
import {Provider} from 'react-redux';
import {Router} from 'react-router';
import Routes from './Routes';

/*
 * Google Analytics setup
 */
var ReactGA = require('react-ga');
ReactGA.initialize('UA-88714128-1');

function logPageView() {
    ReactGA.set({page: window.location.pathname});
    ReactGA.pageview(window.location.pathname);
}

const Root = ({store, history}) => (
    <Provider store={store}>
        <Router history={history} onUpdate={logPageView} routes={Routes} />
    </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root/Root.js